// src/components/modals/RewardModal.jsx
import React from 'react';
import { Sparkles } from 'lucide-react';
import Mascot from '../Mascot';

export default function RewardModal({ 
  reward, 
  onClose, 
  onAction, 
  currentSkin, 
  congratulation,
  zIndex 
}) {
  if (!reward) return null;

  const isSkin = reward.category === 'skin';

  return (
    <div 
      className="fixed inset-0 bg-slate-900/90 backdrop-blur-xl flex items-center justify-center p-4 animate-in fade-in duration-500" 
      style={{ zIndex: zIndex || 250 }}
    >
      {/* 🎉 EFECTO DE CONFETI */}
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        {[...Array(15)].map((_, i) => (
          <div 
            key={i} 
            className="confetti"
            style={{
              left: `${Math.random() * 100}%`,
              backgroundColor: ['#6366f1', '#a855f7', '#ec4899', '#eab308'][Math.floor(Math.random() * 4)],
              animationDelay: `${Math.random() * 3}s`,
              animationDuration: `${2 + Math.random() * 2}s`,
              position: 'absolute', 
              width: '10px', 
              height: '10px', 
              animationName: 'confetti-fall', 
              animationTimingFunction: 'linear', 
              animationIterationCount: 'infinite'
            }}
          />
        ))}
      </div>

      {/* ✅ CONTENEDOR PRINCIPAL - TAMAÑO DEL COFRE */}
      <div className="bg-white rounded-[3rem] p-8 w-full max-w-sm text-center shadow-[0_0_100px_rgba(79,70,229,0.4)] relative animate-in zoom-in-75 duration-500 border-8 border-amber-300">
        <div className="absolute inset-0 bg-gradient-to-b from-amber-50 to-white rounded-[2.5rem] -z-10" />
        <Sparkles className="absolute -top-10 -right-10 text-amber-400 animate-bounce" size={80} />
        <Sparkles className="absolute -bottom-10 -left-10 text-amber-400 animate-pulse" size={60} />

   {/* ✅ DIÁLOGO DE LA MASCOTA - PEGADO A LA MASCOTA */}
{congratulation && (
  <div className="absolute -top-18 right-2 bg-white text-slate-700 px-3 py-2 rounded-xl shadow-lg max-w-[160px] z-30 animate-in fade-in slide-in-from-right-3 duration-500 border-2 border-indigo-100">
    <p className="text-[10px] font-bold leading-tight">
      {congratulation}
    </p>
    {/* Flecha apuntando hacia abajo-derecha (hacia la mascota) */}
    <div className="absolute -bottom-1 right-4 w-0 h-0 border-l-4 border-l-transparent border-r-4 border-r-transparent border-t-4 border-t-white drop-shadow-sm" />
  </div>
)}

{/* ✅ MASCOTA - EN LA ESQUINA SUPERIOR DERECHA */}
<div className="absolute top-20 -right-2 w-24 h-24 drop-shadow-2xl z-20">
  <Mascot 
    type={currentSkin} 
    isJumping={true} 
  />
</div>

        {/* ✅ CONTENIDO - ESTILO DEL COFRE */}
        <div className="mt-4">
          <h3 className="text-[10px] font-black text-amber-600 uppercase tracking-[0.3em] mb-2">
            {isSkin ? '¡Desbloqueo Legendario!' : '¡Nuevo Tema!'}
          </h3>
          
          <h2 className="text-3xl font-black text-slate-800 mb-6 leading-tight">
            ¡LO LOGRASTE!
          </h2>

          {/* ✅ CONTENEDOR DE LA RECOMPENSA (igual que el cofre) */}
          <div className="bg-white rounded-[2rem] p-6 mb-6 shadow-inner border-2 border-amber-100 flex flex-col items-center">
            
            {/* ✅ IMAGEN O EMOJI */}
            {isSkin && reward.img ? (
              <img 
                src={reward.img} 
                className="w-32 h-32 object-contain mb-3 animate-in slide-in-from-bottom-10 duration-700" 
                alt={reward.name}
              />
            ) : (
              <span className="text-6xl mb-3 animate-bounce block">
                {reward.emoji || '📚'}
              </span>
            )}
            
            <p className="text-xl font-black text-indigo-900 tracking-tight mb-2">
              {reward.name || reward.title}
            </p>
            
            {reward.greeting && (
              <div className="mt-2 p-2 bg-indigo-50 rounded-xl border border-indigo-100 text-[10px] italic font-bold text-indigo-700 leading-relaxed">
                "{reward.greeting}"
              </div>
            )}
          </div>

          {/* BOTONES - ESTILO DEL COFRE */}
          <div className="grid gap-3">
        {onAction && (
  <button
    onClick={async () => {
      onAction(); // 1️⃣ Equipar la skin
      await new Promise(resolve => setTimeout(resolve, 100)); // 2️⃣ Esperar 100ms
      onClose(); // 3️⃣ Cerrar y reabrir la tienda
    }}
    className="w-full py-4 bg-gradient-to-r from-indigo-500 to-purple-600 text-white rounded-2xl font-black text-base shadow-xl shadow-indigo-200 border-b-6 border-indigo-800 active:border-b-0 active:translate-y-2 transition-all"
  >
    {isSkin ? 'EQUIPAR AHORA' : 'SET DISPONIBLE EN TU BIBLIOTECA'}
  </button>
)}

            
            <button
              onClick={onClose}
              className="w-full py-4 bg-gradient-to-r from-amber-400 to-orange-500 text-white rounded-2xl font-black text-base shadow-xl shadow-orange-200 border-b-6 border-orange-700 active:border-b-0 active:translate-y-2 transition-all"
            >
              {isSkin ? 'SEGUIR COMPRANDO' : '¡GENIAL!'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
